import {environment} from '../../../../../environments/environment';
import * as Raven from 'raven-js';
import {ErrorHandler, ModuleWithProviders, NgModule} from '@angular/core';
import {RavenErrorHandler} from './raven-error.handler';

@NgModule()
export class SentryModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: SentryModule,
      providers : environment.production ? [
        { provide: ErrorHandler, useClass: RavenErrorHandler },
        RavenErrorHandler
      ] : [RavenErrorHandler],
    };
  }

  public static configure() {
    if (environment.production)
      Raven.config('https://1f615d4615a1425aa8dd603393fe22b4@sentry.io/285319').install();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/modules/sentry/sentry.module.ts